import React, { useEffect, useState } from 'react'
import './styles.scss'
const addSquare = (
  elements: number,
  content: () => JSX.Element | string,
  size: number,
  breackafter: number,
  direction?: 'rl' | 'lr'
) => {
  let ret = []
  let x
  let y
  let col = 0
  let row = 0
  let offsetx = 0
  for (let element: number = 0; element < elements; element++) {
    if (direction === 'rl') offsetx = -size

    x = col * size
    if (direction === 'rl') x = -col * size

    y = row * size
    if ((col % (breackafter - 1) === 0 && col !== 0) || breackafter - 1 <= 0) {
      col = -1
      row++
    }
    col++
    ret.push(<g transform={`translate(${x},${y})`}>{content()}</g>)
  }
  return ret
}
export const SquareGrid = ({
  cellcount,
  breackafter = 5,
  groupbreakafter = 2,
  cellsize,
  cellspace,
  groupspace,
  cellcontent,
  direction = 'lr'
}: GridProps) => {
  const [positions, setPositions] = useState<JSX.Element[]>()

  useEffect(() => {
    const sizenspace = cellsize + cellspace
    const groupcount = Math.ceil(cellcount / Math.pow(breackafter, 2))
    let cellstoplace = cellcount

    let newpos = addSquare(
      groupcount,
      () => {
        let countofcellsingroup = Math.min(
          Math.pow(breackafter, 2),
          cellstoplace
        )
        cellstoplace -= countofcellsingroup
        return (
          <>
            {addSquare(
              countofcellsingroup,
              () => cellcontent,
              sizenspace,
              breackafter,
              direction
            )}
          </>
        )
      },
      sizenspace * breackafter + groupspace,
      groupbreakafter,
      direction
    )
    setPositions(newpos)
  }, [cellcount, cellsize, cellspace, groupspace, cellcontent])

  return <g className='SquareGrid'>{positions && positions.map(p => p)}</g>
}
